import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { t } from "@lingui/core/macro";
import { useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";

import { selectCognitoId } from "../../redux/app/appSelectors";
import FeedbackDialog from "./FeedbackDialog";

export default function ErrorPage({ title, message }: { title: string; message: string }) {
  const [isFeedbackDialogOpen, setIsFeedbackDialogOpen] = useState(false);

  const cognitoId = useSelector(selectCognitoId);
  const source = "errorBoundary";

  // Centered via auto margins within whichever flex-column shell renders it: the #root
  // shell for full-page errors, or the authenticated content area for nested errors.
  // Both are min-h-screen, so the card sits in the middle without owning the viewport itself.
  return (
    <div className="m-auto w-full max-w-xl p-4">
      <Card className="flex flex-col items-center gap-4 p-8">
        <ExclamationCircleIcon className="h-9 w-auto text-muted-foreground" />
        <h1 className="text-center text-xl">{title}</h1>
        <p className="text-center [textWrap:balance]">{message}</p>
        <Button className="w-full" onClick={() => window.location.reload()}>
          {t`Refresh`}
        </Button>
        <Button
          variant="ghost"
          className="w-full"
          onClick={() => {
            if (cognitoId) {
              setIsFeedbackDialogOpen(true);
            } else {
              window.location.href = "mailto:accounts@monetary-meals.com";
            }
          }}
        >
          {t`Report Issue`}
        </Button>
        <FeedbackDialog source={source} isOpen={isFeedbackDialogOpen} onClose={() => setIsFeedbackDialogOpen(false)} />
      </Card>
    </div>
  );
}
